import flagKeys from '@/constants/flagKeys';
import OffersList from '@/views/Offers/OffersList/OffersList.vue';
import { offersValidator } from '@/router/validators/navbar';

import { Route } from '../route.model';
import { IBusinessType } from '@/models/business';

const specialCoinsOffers = new Route(
  '/special-coins-offers',
  'special-coins-offers',
  OffersList,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    validator: () => offersValidator(),
    navbar: {
      name: 'Offers',
      icon: 'special-coin',
      description:
        'Encourage both new & repeat business by creating one-time deals & birthday offers.'
    },
    pageView: {
      eventLabel: 'Special Coin Offers'
    },
    feature: {
      type: IBusinessType.INSTORE
    }
  }
);

export { specialCoinsOffers };
export default specialCoinsOffers;
